"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const decodeobjects_1 = require("./decodeobjects");
const decodinghelpers_1 = require("./decodinghelpers");
const util_1 = require("./util");
// Token sends
function decodeSendTransaction(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bcp/send", sender: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.source, "source")), recipient: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.destination, "destination")), amount: decodeobjects_1.decodeAmount(decodinghelpers_1.ensure(msg.amount)), memo: msg.memo || undefined });
}
// Atomic swaps
function decodeSwapOfferTx(base, msg) {
    const hash = decodinghelpers_1.ensure(msg.preimageHash, "preimageHash");
    if (hash.length !== 32) {
        throw new Error("Hash must be 32 bytes (sha256)");
    }
    const prefix = util_1.addressPrefix(base.chainId);
    const parsed = Object.assign(Object.assign({}, base), { kind: "bcp/swap_offer", hash: hash, sender: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.source, "source")), recipient: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.destination, "destination")), timeout: { timestamp: decodinghelpers_1.asIntegerNumber(decodinghelpers_1.ensure(msg.timeout, "timeout")) }, amounts: (msg.amount || []).map(decodeobjects_1.decodeAmount) });
    return msg.memo ? Object.assign(Object.assign({}, parsed), { memo: msg.memo }) : parsed;
}
function decodeSwapClaimTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bcp/swap_claim", swapId: {
            data: decodinghelpers_1.ensure(msg.swapId),
        }, preimage: decodinghelpers_1.ensure(msg.preimage) });
}
function decodeSwapAbortTransaction(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bcp/swap_abort", swapId: {
            data: decodinghelpers_1.ensure(msg.swapId),
        } });
}
// Usernames
function decodeRegisterUsernameTx(base, msg) {
    const targets = decodinghelpers_1.ensure(msg.targets, "targets").map(decodeobjects_1.decodeChainAddressPair);
    return Object.assign(Object.assign({}, base), { kind: "bns/register_username", username: decodinghelpers_1.ensure(msg.username, "username"), targets: targets });
}
function decodeUpdateTargetsOfUsernameTx(base, msg) {
    const targets = decodinghelpers_1.ensure(msg.newTargets, "newTargets").map(decodeobjects_1.decodeChainAddressPair);
    return Object.assign(Object.assign({}, base), { kind: "bns/update_targets_of_username", username: decodinghelpers_1.ensure(msg.username, "username"), targets: targets });
}
function decodeTransferUsernameTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/transfer_username", username: decodinghelpers_1.ensure(msg.username, "username"), newOwner: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.newOwner, "newOwner")) });
}
// Accounts
function decodeUpdateAccountConfigurationTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/update_account_configuration", configuration: decodeobjects_1.decodeAccountConfiguration(prefix, decodinghelpers_1.ensure(msg.patch, "patch")) });
}
function decodeRegisterDomainTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/register_domain", domain: decodinghelpers_1.ensure(msg.domain, "domain"), admin: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.admin, "admin")), hasSuperuser: decodinghelpers_1.ensure(msg.hasSuperuser, "hasSuperuser"), broker: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.broker, "broker")) || undefined, msgFees: decodinghelpers_1.ensure(msg.msgFees, "msgFees").map(decodeobjects_1.decodeAccountMsgFee), accountRenew: decodinghelpers_1.asIntegerNumber(decodinghelpers_1.ensure(msg.accountRenew, "accountRenew")) });
}
function decodeTransferDomainTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/transfer_domain", domain: decodinghelpers_1.ensure(msg.domain, "domain"), newAdmin: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.newAdmin, "newAdmin")) });
}
function decodeRenewDomainTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/renew_domain", domain: decodinghelpers_1.ensure(msg.domain, "domain") });
}
function decodeDeleteDomainTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/delete_domain", domain: decodinghelpers_1.ensure(msg.domain, "domain") });
}
function decodeRegisterAccountTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/register_account", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name"), owner: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.owner, "owner")), targets: decodinghelpers_1.ensure(msg.targets, "targets").map(decodeobjects_1.decodeBlockchainAddress), broker: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.broker, "broker")) || undefined });
}
function decodeTransferAccountTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/transfer_account", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name"), newOwner: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.newOwner, "newOwner")) });
}
function decodeReplaceAccountTargetsTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/replace_account_targets", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name"), newTargets: decodinghelpers_1.ensure(msg.newTargets, "newTargets").map(decodeobjects_1.decodeBlockchainAddress) });
}
function decodeDeleteAccountTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/delete_account", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name") });
}
function decodeDeleteAllAccountsTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/delete_all_accounts", domain: decodinghelpers_1.ensure(msg.domain, "domain") });
}
function decodeRenewAccountTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/renew_account", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name") });
}
function decodeAddAccountCertificateTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/add_account_certificate", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name"), certificate: decodinghelpers_1.ensure(msg.certificate, "certificate") });
}
function decodeReplaceAccountMsgFeesTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/replace_account_msg_fees", domain: decodinghelpers_1.ensure(msg.domain, "domain"), newMsgFees: decodinghelpers_1.ensure(msg.newMsgFees, "newMsgFees").map(decodeobjects_1.decodeAccountMsgFee) });
}
function decodeDeleteAccountCertificateTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/delete_account_certificate", domain: decodinghelpers_1.ensure(msg.domain, "domain"), name: decodinghelpers_1.ensure(msg.name, "name"), certificateHash: decodinghelpers_1.ensure(msg.certificateHash, "certificateHash") });
}
// Multisignature contracts
function decodeCreateMultisignatureTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/create_multisignature_contract", participants: decodeobjects_1.decodeParticipants(prefix, msg.participants), activationThreshold: decodinghelpers_1.ensure(msg.activationThreshold, "activationThreshold"), adminThreshold: decodinghelpers_1.ensure(msg.adminThreshold, "adminThreshold") });
}
function decodeUpdateMultisignatureTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/update_multisignature_contract", contractId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.contractId, "contractId")), participants: decodeobjects_1.decodeParticipants(prefix, msg.participants), activationThreshold: decodinghelpers_1.ensure(msg.activationThreshold, "activationThreshold"), adminThreshold: decodinghelpers_1.ensure(msg.adminThreshold, "adminThreshold") });
}
// Escrows
function decodeCreateEscrowTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/create_escrow", sender: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.source, "source")), arbiter: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.arbiter, "arbiter")), recipient: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.destination, "destination")), amounts: decodinghelpers_1.ensure(msg.amount, "amount").map(decodeobjects_1.decodeAmount), timeout: { timestamp: decodinghelpers_1.asIntegerNumber(decodinghelpers_1.ensure(msg.timeout, "timeout")) }, memo: msg.memo !== null ? msg.memo : undefined });
}
function decodeReleaseEscrowTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/release_escrow", escrowId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.escrowId, "escrowId")), amounts: decodinghelpers_1.ensure(msg.amount, "amount").map(decodeobjects_1.decodeAmount) });
}
function decodeReturnEscrowTx(base, msg) {
    return Object.assign(Object.assign({}, base), { kind: "bns/return_escrow", escrowId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.escrowId, "escrowId")) });
}
function decodeUpdateEscrowPartiesTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/update_escrow_parties", escrowId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.escrowId, "escrowId")), sender: msg.source ? util_1.encodeBnsAddress(prefix, msg.source) : undefined, arbiter: msg.arbiter ? util_1.encodeBnsAddress(prefix, msg.arbiter) : undefined, recipient: msg.destination ? util_1.encodeBnsAddress(prefix, msg.destination) : undefined });
}
// Governance
function decodeCreateProposalTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/create_proposal", title: decodinghelpers_1.ensure(msg.title, "title"), action: decodeobjects_1.decodeRawProposalOption(prefix, decodinghelpers_1.ensure(msg.rawOption, "rawOption")), description: decodinghelpers_1.ensure(msg.description, "description"), electionRuleId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.electionRuleId, "electionRuleId")), startTime: decodinghelpers_1.asIntegerNumber(decodinghelpers_1.ensure(msg.startTime, "startTime")), author: util_1.encodeBnsAddress(prefix, decodinghelpers_1.ensure(msg.author, "author")) });
}
function decodeVoteTx(base, msg) {
    const prefix = util_1.addressPrefix(base.chainId);
    return Object.assign(Object.assign({}, base), { kind: "bns/vote", proposalId: decodinghelpers_1.decodeNumericId(decodinghelpers_1.ensure(msg.proposalId, "proposalId")), selection: decodeobjects_1.decodeVoteOption(decodinghelpers_1.ensure(msg.selected, "selected")), voter: msg.voter ? util_1.encodeBnsAddress(prefix, msg.voter) : null });
}
function decodeMsg(base, tx) {
    // Token sends
    if (tx.cashSendMsg)
        return decodeSendTransaction(base, tx.cashSendMsg);
    // Atomic swaps
    if (tx.aswapCreateMsg)
        return decodeSwapOfferTx(base, tx.aswapCreateMsg);
    if (tx.aswapReleaseMsg)
        return decodeSwapClaimTx(base, tx.aswapReleaseMsg);
    if (tx.aswapReturnMsg)
        return decodeSwapAbortTransaction(base, tx.aswapReturnMsg);
    // Usernames
    if (tx.usernameRegisterTokenMsg)
        return decodeRegisterUsernameTx(base, tx.usernameRegisterTokenMsg);
    if (tx.usernameChangeTokenTargetsMsg) {
        return decodeUpdateTargetsOfUsernameTx(base, tx.usernameChangeTokenTargetsMsg);
    }
    if (tx.usernameTransferTokenMsg)
        return decodeTransferUsernameTx(base, tx.usernameTransferTokenMsg);
    // Accounts
    if (tx.accountUpdateConfigurationMsg) {
        return decodeUpdateAccountConfigurationTx(base, tx.accountUpdateConfigurationMsg);
    }
    if (tx.accountRegisterDomainMsg)
        return decodeRegisterDomainTx(base, tx.accountRegisterDomainMsg);
    if (tx.accountTransferDomainMsg)
        return decodeTransferDomainTx(base, tx.accountTransferDomainMsg);
    if (tx.accountRenewDomainMsg)
        return decodeRenewDomainTx(base, tx.accountRenewDomainMsg);
    if (tx.accountDeleteDomainMsg)
        return decodeDeleteDomainTx(base, tx.accountDeleteDomainMsg);
    if (tx.accountRegisterAccountMsg)
        return decodeRegisterAccountTx(base, tx.accountRegisterAccountMsg);
    if (tx.accountTransferAccountMsg)
        return decodeTransferAccountTx(base, tx.accountTransferAccountMsg);
    if (tx.accountReplaceAccountTargetsMsg) {
        return decodeReplaceAccountTargetsTx(base, tx.accountReplaceAccountTargetsMsg);
    }
    if (tx.accountDeleteAccountMsg)
        return decodeDeleteAccountTx(base, tx.accountDeleteAccountMsg);
    if (tx.accountFlushDomainMsg)
        return decodeDeleteAllAccountsTx(base, tx.accountFlushDomainMsg);
    if (tx.accountRenewAccountMsg)
        return decodeRenewAccountTx(base, tx.accountRenewAccountMsg);
    if (tx.accountAddAccountCertificateMsg) {
        return decodeAddAccountCertificateTx(base, tx.accountAddAccountCertificateMsg);
    }
    if (tx.accountReplaceAccountMsgFeesMsg) {
        return decodeReplaceAccountMsgFeesTx(base, tx.accountReplaceAccountMsgFeesMsg);
    }
    if (tx.accountDeleteAccountCertificateMsg) {
        return decodeDeleteAccountCertificateTx(base, tx.accountDeleteAccountCertificateMsg);
    }
    // Multisignature contracts
    if (tx.multisigCreateMsg)
        return decodeCreateMultisignatureTx(base, tx.multisigCreateMsg);
    if (tx.multisigUpdateMsg)
        return decodeUpdateMultisignatureTx(base, tx.multisigUpdateMsg);
    // Escrows
    if (tx.escrowCreateMsg)
        return decodeCreateEscrowTx(base, tx.escrowCreateMsg);
    if (tx.escrowReleaseMsg)
        return decodeReleaseEscrowTx(base, tx.escrowReleaseMsg);
    if (tx.escrowReturnMsg)
        return decodeReturnEscrowTx(base, tx.escrowReturnMsg);
    if (tx.escrowUpdatePartiesMsg)
        return decodeUpdateEscrowPartiesTx(base, tx.escrowUpdatePartiesMsg);
    // Governance
    if (tx.govCreateProposalMsg)
        return decodeCreateProposalTx(base, tx.govCreateProposalMsg);
    if (tx.govVoteMsg)
        return decodeVoteTx(base, tx.govVoteMsg);
    throw new Error("unknown message type in transaction");
}
exports.decodeMsg = decodeMsg;
//# sourceMappingURL=decodemsg.js.map